<template>
  <main class="bodymain" v-html="myOutput" v-cloak>
  </main>
</template>

<script>
import moment from 'moment';
import VueAllInitMixin from '@/mixins/VueAllInit.js';
 
// define a mixin object
export default {
  name: 'single',
    data: () => {
      return {
        myImage:{
          source_url:"loading"
        },
        myDate:'',
        myTitle:'',
        mainContent : '',
        myslug:'',
        loadedSidebar: '<div id="sidebar">'+document.querySelector('#mysidebar').innerHTML+'</div>'
      }
    },
    components:{
     },
    mixins: [VueAllInitMixin],
    created () {
      this.getMainContent();
    },
    beforeMount(){
      
    },
    beforeUpdate(){
    },

    updated (){
      this.VueAllInit();
      this.$nextTick(()=>{
        this.loadedSidebar='<div id="sidebar">'+document.querySelector('#mysidebar').innerHTML+'</div>';
        //console.log(this.$refs.canvas.clientWidth) //assuming you've added a "canvas" ref
      });
    },
    computed: {
      myOutput: function () {
        // console.log("header path"+this.myImage.source_url);
          let myOP ="";
          if (this.myImage.source_url!=="loading"){
            myOP = "<figure class='singleheaderimage'><img src='"+this.myImage.source_url+"' alt='"+this.myImage.alt_text+"'></figure>";
          }
          myOP += "<date class='h1'>" + this.myDate + "</date>";
          myOP += '<h2 class="singleheader">' + this.myTitle + '</h2>';
          myOP +=this.mainContent;
          myOP+=this.loadedSidebar;
        return myOP;
      }
    },
    methods: {
      getMainContent(){
        this.$http.get(
          'wp/v2/posts?slug='+ this.$route.params.myslug+'&_embed' )
          .then( (response) => {
          // For Slug Based Rest Call
          // let myHTML =
          this.myDate=moment(response.data[0].date).format("DD MMM YYYY");
          this.myTitle=response.data[0].title.rendered;
          this.mainContent = response.data[0].content.rendered;
          this.myImage= response.data[0]._embedded['wp:featuredmedia']['0'];
          // For ID based Rest Call
          //this.mainContent = response.data.content.rendered;
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
}

</script>
<style>
v-cloak{
  visibility: hidden;
  
}

</style>
